export default function eta(seconds) {
    const result = seconds > 0 ? new Date(seconds * 1000).toISOString().slice(11, 19) : '-';
    return result;
}